import React, { FC, useEffect, useRef } from 'react';
import { useWizardStore } from 'src/common/components/wizard/store';
import { WizardWidget } from 'src/common/components/wizard/widget';
import { EventBus } from 'src/common/EventBus';
import { functionNoop } from 'src/utils/function/noop';
import { PageLayout } from '.';

export const PageLayoutWithSidebar: FC<{}> = ({ children }) => {
  const wizardContentOpenRef = useRef(functionNoop);
  const wizardLoadingOpenRef = useRef(functionNoop);
  const isWizardOnProgress = useWizardStore(
    (state) => state.progress !== 0 && state.progress < 100 && !state.isWizardCompleted
  );
  useEffect(() => {
    const onWizardOpened = () => {
      if (!isWizardOnProgress) {
        wizardContentOpenRef.current();
      } else {
        wizardLoadingOpenRef.current();
      }
    };

    EventBus.on('wizard:open', onWizardOpened);

    return () => {
      EventBus.off('wizard:open', onWizardOpened);
    };
  }, [isWizardOnProgress]);

  return (
    <>
      <PageLayout sidebarEnabled>{children}</PageLayout>
      <WizardWidget loadingOpenRef={wizardLoadingOpenRef} contentOpenRef={wizardContentOpenRef} />
    </>
  );
};
